import React from 'react';
import clsx from 'clsx';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, A11y } from 'swiper/modules';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft, faCircle } from '@fortawesome/free-solid-svg-icons';

import Section from '@common/Section';
import Container from '@common/Container';
import Row from '@common/Row';
import Heading from '@common/Heading';
import Img from '@common/Image';
import RichText from '@common/RichText';
import Quote from '@common/Quote';


const ReviewsSlider = ({ data }) => {
  const {
    title,
    showTitle,
    list,
    bgColour
  } = data;
  return (
    <Section>
      <div className={clsx({[`bg-${bgColour} py-5`]: bgColour })}>
        <Container style={{marginBottom: 50}}>
          <Row className='flex-column flex-lg-row justify-content-end mb-4'>
            {(showTitle && title) && <Heading type='h2' className='col-lg-7 mb-0'>{title}</Heading>}
            <div className='col-auto align-self-end'>
              <div className='prev fa-layers fa-fw fa-2xl'>
                <FontAwesomeIcon icon={faCircle}/>
                <FontAwesomeIcon icon={faChevronLeft} transform='shrink-7' inverse/>
              </div>
              <div className='next fa-layers fa-fw fa-2xl'>
                <FontAwesomeIcon icon={faCircle}/>
                <FontAwesomeIcon icon={faChevronRight} transform='shrink-7' inverse/>
              </div>
            </div>
          </Row>
        </Container>
      </div>  
      <Container style={{marginTop: -100}}>
        <Swiper
          className='overflow-visible'
          modules={[Navigation, A11y]} 
          loop
          centeredSlides
          slidesPerView={1}
          spaceBetween={20}
          navigation={{
            nextEl: '.next',
            prevEl: '.prev',
          }}
          breakpoints={{
            1200: {
              slidesPerView: 3,
              spaceBetween: 60
            },
            992: {
              slidesPerView: 2.5,
              spaceBetween: 20
            },
            768: {
              slidesPerView: 1.75,
              spaceBetween: 20
            }
          }}
          >
          {list.map((card, index) => (
            <SwiperSlide key={index} className='d-flex flex-column border border-black border-3 rounded bg-white p-4 align-items-center'>
              {card.bgColour && <Quote colour={card.bgColour}/>}
              {card.review && 
                <div className='mt-3 flex-fill'>
                  <RichText json={card.review}/>
                </div>
              }
              {(card.name || card.company) &&
                <div className='align-self-start fs-20'>
                  {card.name && <p className='mb-0'>{card.name}</p>}
                  {card.company && <p>{card.company}</p>}
                </div>
              }
              {card.image &&
                <Img
                  loading='eager'
                  image={card.image.gatsbyImageData}
                  file={card.image.file}
                  alt={card.image.description}
                  className='mt-3'
                />
              }
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </Section>
  )
}

export default ReviewsSlider
